// extracted by mini-css-extract-plugin
export default {"menuButton":"Menu_menuButton__GB6L+","menuBody":"Menu_menuBody__M-Cv1","menuItemIcon":"Menu_menuItemIcon__e3rPQ"};